import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CircularProgress } from 'dist/icons/loading.svg';

export const GlobalLoading = () => {
  const { t } = useTranslation();

  return (
    <div className="app-loading-wrapper">
      <div className="app-loading">
        <CircularProgress width={40} height={40} />
        <div className="app-loading__text">{t('translation:global_loading.loading')}</div>
      </div>
    </div>
  );
};
